export const authRoles = {
  sa: ['SA'], // Only Super Admin has access
  admin: ['ADMIN'], // Only SA & Admin has access
  editor: ['SA', 'ADMIN', 'EDITOR'], // Only SA & Admin & Editor has access
  guest: ['SA', 'ADMIN', 'EDITOR', 'GUEST'], // Everyone has access
  orgUser: ['OU'], // Everyone has access
};
